import { API_URL } from "../utils/AppApiUrl";
import {
  post,
  postFile,
  postWithImgResponse,
} from "../utils/httpClients-methods";
import tokenHttpClient from "../utils/httpClient";

export const listQueryTypeDetailsService = async (
  baseURL,
  requestBody = {}
) => {
  try {
    const listQueryTypeDetailsResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.listQueryTypeDetails}`,
      JSON.stringify(requestBody)
    );
    if (
      listQueryTypeDetailsResponse?.status === 200 &&
      listQueryTypeDetailsResponse?.data
    ) {
      return listQueryTypeDetailsResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const addNewQueryService = async (baseURL, requestBody) => {
  try {
    const requestObj = {
      subTypeCode: requestBody.subTypeCode,
      comment: requestBody.comment,
      typeCode: requestBody.typeCode,
      userName: requestBody?.userName + "",
      is_attachment: requestBody?.is_attachment,
      file: requestBody?.is_attachment ? requestBody?.file : undefined,
    };
    const addnewQueryResponse = await postFile(
      tokenHttpClient,
      `${baseURL}${API_URL.createNewQuery}`,
      requestObj
    );
    if (addnewQueryResponse?.status === 200 && addnewQueryResponse?.data) {
      return addnewQueryResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const queryListService = async (baseURL, requestBody) => {
  try {
    const listQueryTypeDetailsResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.queryList}`,
      JSON.stringify(requestBody)
    );

    if (
      listQueryTypeDetailsResponse?.status === 200 &&
      listQueryTypeDetailsResponse?.data
    ) {
      return listQueryTypeDetailsResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const queryThreadListService = async (baseURL, requestBody) => {
  try {
    const listQueryThreadResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.queryThreadList}`,
      JSON.stringify(requestBody)
    );
    if (
      listQueryThreadResponse?.status === 200 &&
      listQueryThreadResponse?.data
    ) {
      return listQueryThreadResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const queryAttacgedListService = async (baseURL, requestBody) => {
  try {
    const listQueryAttachmentResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.queryAttachmentList}`,
      JSON.stringify(requestBody)
    );
    if (listQueryAttachmentResponse?.status === 200) {
      return listQueryAttachmentResponse?.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const saveQueryThreadDetails = async (baseURL, requestBody) => {
  try {
    const saveQueryThreadDetailsResponse = await postFile(
      tokenHttpClient,
      `${baseURL}${API_URL.saveQueryThreadDetails}`,
      requestBody
    );
    if (saveQueryThreadDetailsResponse?.status === 200) {
      return saveQueryThreadDetailsResponse?.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const downloadQueryDocument = async (baseURL, documentId) => {
  try {
    const downloadQueryDocumentResponse = await postWithImgResponse(
      tokenHttpClient,
      `${baseURL}${API_URL.downloadQueryDocument}?documentId=${documentId}`
    );
    if (downloadQueryDocumentResponse?.status === 200) {
      return downloadQueryDocumentResponse;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const searchVendorQuery = async (baseURL, requestBody) => {
  try {
    const searchVendorQueryResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.searchVendorQuery}`,
      JSON.stringify(requestBody)
    );
    if (searchVendorQueryResponse?.status === 200) {
      return searchVendorQueryResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
